var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#008000",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 25C45.5 25 41.75 26.875 35 26.875C28.375 26.875 24.375 25 23.75 25C23.125 25 22.5 25.5 22.5 26.25V43.75C22.5 44.5 23.125 45 23.75 45C24.5 45 28.125 43.125 35 43.125C41.75 43.125 45.5 45 46.25 45C46.875 45 47.5 44.5 47.5 43.75V26.25C47.5 25.5 46.875 25 46.25 25ZM45 42C42.5 41.25 39.25 40.625 35 40.625C30.75 40.625 27.5 41.25 25 42V28C28.25 28.875 31.625 29.375 35 29.375C39.25 29.375 42.5 28.75 45 28V42ZM31.5 33.75L26.875 39.25C29.375 38.875 32.125 38.75 35 38.75C37.875 38.75 40.625 38.875 43.125 39.25L37.5 32.5L34 36.75L31.5 33.75Z",
    fill: "#008000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTours);
export default __webpack_public_path__ + "static/media/tours.647598d3f073071f6dd7203c11037a8d.svg";
export { ForwardRef as ReactComponent };